export default [
  {
    name: 'Dashboard',
    icon: 'ti-dashboard',
    path: '/overview'
  },
  {
    name: 'Transactions',
    icon: 'ti-exchange-vertical',
    path: '/transactions'
  },
  {
    name: 'Budget',
    icon: 'ti-pie-chart',
    path: '/budget'
  },
  {
    name: 'Goals',
    icon: 'ti-target',
    path: '/goals'
  },
  {
    name: 'Rewards',
    icon: 'ti-cup',
    path: '/rewards'
  },
  {
    name: 'Financial Services',
    icon: 'ti-plug',
    path: '/plugins'
  },
  {
    name: 'Settings',
    icon: 'ti-settings',
    path: '/settings'
  },
  
]
